var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Products"},[_c('div',{staticClass:"hero simple",staticStyle:{"background-image":"url('/static/asx/child.head.bg.png')"}},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"hero-title"},[_vm._v(_vm._s(_vm.$t('messages.privacyPolicy')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-212e0af0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/firstLevel/Privacy.vue
// module id = null
// module chunks = 